import Humanize from 'humanize-plus';

import { PROGRAM_STREAM_TYPE, CUE_PROGRAM_TYPE, SAT_COURSES } from '@~/constants/program';

export const getCurrentSelectedProgram = programs => {
  if (!programs || !Array.isArray(programs)) {
    return null;
  }

  const [program] = programs || [];

  return programs.find(prgm => prgm.is_current) || program;
};

const filterWinsDashboardProgram = program => {
  const { stream: programStream, cue_program_type: programType } = program || {};

  return (
    programType === CUE_PROGRAM_TYPE.CORE &&
    Object.keys(PROGRAM_STREAM_TYPE).includes(programStream)
  );
};

export const getWinsDashboardPrograms = (programs = []) => {
  const shouldReturnEmptyPrograms = (programs?.length || 0) === 0;

  if (shouldReturnEmptyPrograms) {
    return [];
  }

  const filteredPrograms = programs.filter(filterWinsDashboardProgram);

  return filteredPrograms.map(program => {
    const { stream: programStream, name: programName } = program;

    return {
      ...program,
      text: `${Humanize.titleCase(programStream)} : ${Humanize.titleCase(programName)}`,
    };
  });
};

const satCourses = Object.values(SAT_COURSES);

const isSatCourseSelected = (courseValue, selectedCourse) => {
  if (!selectedCourse) return false;

  const isSatCourse =
    courseValue &&
    courseValue.startsWith('SAT') &&
    satCourses.some(course => course.split('-')[0] === selectedCourse.split('-')[0]);

  return isSatCourse;
};

export const getFilteredPrograms = ({ allPrograms, courseValue }) => {
  const demoPrograms = (allPrograms || []).filter(program => program?.is_demo === true);

  if (!courseValue) return demoPrograms;

  return demoPrograms.filter(program => {
    const { cue_program_type: cueProgramType, stream } = program;
    const isSatCourse = isSatCourseSelected(courseValue, stream);

    return (
      (stream === courseValue || isSatCourse) &&
      cueProgramType !== CUE_PROGRAM_TYPE.ELECTIVES
    );
  });
};
